import moment from 'moment';
import { EMARPOLDocuments, TMARPOLTank } from '../../marpol/@types';
import { TCRBPlace } from '../@types';
import {
    ECRBRecordCode,
    ECRBRecordState,
    TCRBCommonData,
    TCRBCommonFields,
} from '../@types';

export type TCRBItem22 = {
    tanks: TCRBItem22Tank[];
};

export type TCRBItem22Tank = {
    selectedTank: TMARPOLTank;
    newQuantity: number;
    transferQuantity: number;
    startDate: string;
    startTime: string;
    endDate: string;
    endTime: string;
};

export type TCRBItem22P1 = {
    totalOperatedWaterVolume: number;
};

export type TCRBItem23 = {
    placeOfBallast: TCRBPlace;
};

export type TCRBItem25 = {
    speed: number;
};

export type TCRBH1 = TCRBCommonFields &
    TCRBCommonData & {
        id: string;
        recordCode: ECRBRecordCode.CRBH;
        item22: TCRBItem22;
        item22P1: TCRBItem22P1;
        item23: TCRBItem23;
        item25: TCRBItem25;
    };

export type TCRBH = TCRBH1;

const CRBH_DEFAULTS: {
    H: TCRBH1;
} = {
    H: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.CRB,
        state: ECRBRecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item22: {
            tanks: [],
        },
        item22P1: {
            totalOperatedWaterVolume: 0,
        },
        item23: {
            placeOfBallast: {
                place: 'AT_SEA',
                startPosition: {
                    latitude: '',
                    longitude: '',
                },
                endPosition: {
                    latitude: '',
                    longitude: '',
                },
            },
        },
        item25: {
            speed: 0,
        },
        recordCode: ECRBRecordCode.CRBH,
    },
};

export { CRBH_DEFAULTS };
